import MainTable from "../../../components/mainpage/mainTable";
import {connect} from "react-redux";
import {fetchResultByType, resultSocket} from "../../../redux/actions/resultActions";
import {withTranslation} from "react-i18next";
import React from "react";
import BodyMt from "../../../components/results/mt/bodyMt";

const ResultTNPage = ({...props}) => {

    return (
        <MainTable>
            <BodyMt type="tn" {...props}/>
        </MainTable>
    )
};

const mapStateToProps = state => ({
    historyResult: state.resultTn.result,
    drawResult: state.resultTn.draw
});


export default connect(
    mapStateToProps,
    {
        fetchResultByType,
        resultSocket
    }
)(withTranslation()(ResultTNPage));
